import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PortfolioSection from './components/PortfolioSection';
import PartnersSection from './components/PartnersSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    document.title = 'JSPM Engineering Co., Ltd. - Excellence in Stainless Steel Engineering';
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <PortfolioSection />
      <PartnersSection />
      <ContactSection />
      
      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-6 text-center">
          <div className="mb-4">
            <h3
              className="text-2xl font-bold flex items-baseline justify-center"
              style={{ fontFamily: '"Freestyle Script", "Pacifico", cursive' }}
              lang="en"
            >
              <span className="text-5xl">J</span>
              <span className="-ml-2 text-2xl">SPM</span>
              <span className="ml-2 text-2xl">Engineering Co., Ltd.</span>
            </h3>
          </div>
          <p className="text-gray-400">
            © 2024 JSPM Engineering Co., Ltd. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
